"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgInGoalFail = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgInGoalFail = function SvgInGoalFail(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11 20.167c-5.055 0-9.167-4.113-9.167-9.167 0-5.055 4.112-9.167 9.167-9.167S20.167 5.945 20.167 11 16.054 20.167 11 20.167zm0-16.959c-4.296 0-7.792 3.496-7.792 7.792 0 4.296 3.496 7.792 7.792 7.792 4.296 0 7.792-3.496 7.792-7.792 0-4.296-3.496-7.792-7.792-7.792z",
    fill: "#C446D9"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11 4.583a.688.688 0 01-.688-.687V.687a.688.688 0 011.376 0v3.209c0 .38-.309.687-.688.687zM21.313 11.688h-3.209a.688.688 0 010-1.376h3.209a.688.688 0 010 1.376zM11 22a.688.688 0 01-.688-.688v-3.208a.688.688 0 011.376 0v3.209c0 .379-.309.687-.688.687zM3.896 11.688H.688a.688.688 0 010-1.376h3.208a.688.688 0 010 1.376zM11 13.75A2.753 2.753 0 018.25 11 2.753 2.753 0 0111 8.25 2.753 2.753 0 0113.75 11 2.753 2.753 0 0111 13.75zm0-4.125c-.758 0-1.375.617-1.375 1.375s.617 1.375 1.375 1.375 1.375-.617 1.375-1.375S11.758 9.625 11 9.625z",
    fill: "#C446D9"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#F9FCFE",
    strokeWidth: 5,
    strokeLinecap: "round",
    d: "M4.707 17.303L17.435 4.575"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#C446D9",
    strokeLinecap: "round",
    d: "M3.293 18.718L18.849 3.161"
  }));
};

exports.SvgInGoalFail = SvgInGoalFail;